<template>
  <transition name="fadeout">
    <div class="screen" v-if="show">
      <div class="highlight">
        <SpinStamp :stamp="stamp" :imprinted="imprinted"/>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
// import FlipStamp from './FlipStamp.vue';
import SpinStamp from './SpinStamp.vue';

export default {
  name: 'highlight-stamp',
  components: { SpinStamp },
  data() {
    return {
      show: false,
      imprinted: false,
    };
  },
  computed: {
    ...mapGetters(['currentStamp']),
    stamp() {
      return this.currentStamp ? this.currentStamp : {
        id: '',
        img: '',
        val: '',
      };
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.imprinted = false;
    },
    startAnimation() {
      this.open();
      window.setTimeout(() => {
        this.close();
      }, 4500);
    },
  },
  watch: {
    currentStamp(val) {
      if (val) {
        // スタンプがアクティブになった時点で表示開始
        this.startAnimation();
        window.setTimeout(() => {
          this.imprinted = true;
        }, 1200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.screen {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 2000;
  // background-color: rgba(255,255,255,0.95);
  background-color: rgba(#C8DEDB,0.85);  // C8DEDB
  // background-color: #333;
}
.highlight {
  margin: 30vh auto 0;
  width: 60vw;
  height: 60vw;
  max-width: 400px;
  max-height: 400px;
  background-color: #fff9f5;
  // border: 1px solid #08A79D;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fadeout-enter-active {
  // transition: all .2s ease;
}
.fadeout-leave-active {
  transition: all .2s ease;
}
.fadeout-enter, .fadeout-leave-to {
  opacity: 0;
}
</style>
